import styled from 'styled-components';

export const Container = styled.div`
  user-select: none;
`;

export const ContentDiv = styled.div``;

export const ButtonClose = styled.button`
  background-color: ${({ theme }) => theme.colors?.secondary};
  border-radius: 6px;
  padding: 10px;
  border: 0;
  text-align: center;
  color: ${({ theme }) => theme.colors?.text.gray05};
  &:hover {
    background-color: ${({ theme }) => theme.colors?.primary};
  }
`;

export const TitleName = styled.h6`
  font-weight: bold;
`;

export const DitTitle = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  color: ${({ theme }) => theme.colors?.text.primary};
`;

export const DivSubtitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 1rem;

  animation: open 1s;

  @keyframes open {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  opacity: 1;
  height: 100%;
`;

export const DivSubtitleSeparated = styled.div`
  display: flex;
  align-items: center;

  gap: 1rem;
  color: ${({ theme }) => theme.colors?.text.primary};
`;

interface ISubtitle {
  completed?: boolean;
  isApproved?: boolean;
  $selected?: boolean;
}
export const Subtitle = styled.h6<ISubtitle>`
  cursor: ${(props) => (props.isApproved ? 'default' : 'pointer')};
  font-weight: ${(props) => (props.$selected ? 'bold' : 'normal')};
  color: ${(props) =>
    props.$selected
      ? props.theme.colors?.primary
      : props.completed
        ? props.theme.colors?.text.secondary
        : props.theme.colors?.text.primary};
`;

export const SelectedMaterial = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors?.gray01};
  border: 1px solid ${({ theme }) => theme.colors?.primary};
`;

export const SelectedLabel = styled.span`
  color: ${({ theme }) => theme.colors?.text.secondary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
`;

export const SelectedName = styled.span`
  color: ${({ theme }) => theme.colors?.text.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
  font-weight: bold;
`;

export const Separated = styled.h6`
  color: ${({ theme }) => theme.colors?.text.secondary};

  @media screen and (min-width: ${(props) => props.theme.size?.large}) {
    &:before {
      content: '|  ';
    }
  }
`;
